module.exports = __webpack_public_path__ + "img/dead-dry-hairy-tree-01.728cf7b1.png";